document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('.mega-menu-nav__item--has-panel');

  items.forEach(function (item) {
    var trigger = item.querySelector(':scope > .mega-menu-nav__trigger');
    if (!trigger) return;

    // Column-header triggers use "#" as a placeholder URL - stop them navigating
    if (trigger.getAttribute('href') === '#') {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
      });
    }

    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.blur();
      }
    });
  });

  document.addEventListener('click', function (e) {
    items.forEach(function (item) {
      if (!item.contains(e.target)) {
        var trigger = item.querySelector(':scope > .mega-menu-nav__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });
});